var map = {
	"./symbol_0.png": "ccff",
	"./symbol_1.png": "b623",
	"./symbol_2.png": "3394",
	"./symbol_3.png": "e074",
	"./symbol_4.png": "28f9",
	"./symbol_5.png": "20f5",
	"./symbol_6.png": "f753",
	"./symbol_7.png": "834a",
	"./symbol_8.png": "bd25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5dd5";